import React from 'react';
import cn from 'classnames';
import { useTemplateColumns } from '../../services/templateColumnsCalculator';
import styles from './index.module.scss';

const BaseRow = ({ children, className, rootRef }) => {
  const templateColumns = useTemplateColumns();

  return (
    <div
      ref={rootRef}
      className={cn(styles.root, className)}
      style={{ '--grid-template-columns': templateColumns }}
    >
      {children}
    </div>
  );
};

export default BaseRow;
